import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-dark-900 border-t border-dark-700 mt-20">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">SP</span>
              </div>
              <span className="text-xl font-bold gradient-text">SPORTIX</span>
            </div>
            <p className="text-dark-400 text-sm leading-relaxed">
              منصة تأجير الملاعب والمعدات والخدمات الرياضية في العالم العربي
            </p>
            <div className="flex items-center gap-3 mt-4">
              {[Instagram, Twitter, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-8 h-8 rounded-lg bg-dark-700 flex items-center justify-center text-dark-400 hover:text-primary-400 hover:bg-dark-600 transition-colors">
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">الخدمات</h4>
            <ul className="space-y-2">
              {[
                { to: '/listings?type=venue', label: 'تأجير الملاعب' },
                { to: '/listings?type=equipment', label: 'تأجير المعدات' },
                { to: '/listings?type=service', label: 'الخدمات الرياضية' },
                { to: '/register', label: 'إضافة إعلان' }
              ].map(({ to, label }) => (
                <li key={to}><Link to={to} className="text-dark-400 hover:text-primary-400 text-sm transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">المنصة</h4>
            <ul className="space-y-2">
              {[
                { to: '/about', label: 'من نحن' },
                { to: '/how-it-works', label: 'كيف تعمل' },
                { to: '/pricing', label: 'الأسعار' },
                { to: '/blog', label: 'المدونة' }
              ].map(({ to, label }) => (
                <li key={to}><Link to={to} className="text-dark-400 hover:text-primary-400 text-sm transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">تواصل معنا</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-dark-400 text-sm">
                <Mail size={14} className="text-primary-400 flex-shrink-0" />
                info@sportix.com
              </li>
              <li className="flex items-center gap-2 text-dark-400 text-sm">
                <Phone size={14} className="text-primary-400 flex-shrink-0" />
                +971 50 000 0000
              </li>
              <li className="flex items-center gap-2 text-dark-400 text-sm">
                <MapPin size={14} className="text-primary-400 flex-shrink-0" />
                دبي، الإمارات العربية المتحدة
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-700 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-dark-500 text-xs">© {new Date().getFullYear()} SPORTIX. جميع الحقوق محفوظة.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-dark-500 hover:text-dark-300 text-xs transition-colors">سياسة الخصوصية</Link>
            <Link to="/terms" className="text-dark-500 hover:text-dark-300 text-xs transition-colors">الشروط والأحكام</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
